// src/components/AccountDebugger.jsx
// 開発環境でアカウント情報をデバッグするコンポーネント

import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import {
    collection,
    doc,
    getDocs,
    getDoc
} from 'firebase/firestore';
import { db } from '../services/firebase';

const AccountDebugger = ({ accountId }) => {
    const { currentUser } = useAuth();
    const [debugInfo, setDebugInfo] = useState(null);
    const [loading, setLoading] = useState(false);

    const loadDebugInfo = async () => {
        if (!currentUser || !accountId) return;

        try {
            setLoading(true);
            const info = {
                currentUser: {
                    uid: currentUser.uid,
                    email: currentUser.email,
                    displayName: currentUser.displayName
                },
                accountId: accountId,
                accountExists: false,
                accountData: null,
                usersInAccount: [],
                collections: []
            };

            // アカウント情報を取得
            try {
                const accountRef = doc(db, 'accounts', accountId);
                const accountDoc = await getDoc(accountRef);
                if (accountDoc.exists()) {
                    info.accountExists = true;
                    info.accountData = accountDoc.data();
                }
            } catch (error) {
                info.accountError = error.message;
            }

            // ユーザー一覧を取得
            try {
                const usersRef = collection(db, 'accounts', accountId, 'users');
                const usersSnapshot = await getDocs(usersRef);
                info.usersInAccount = usersSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
            } catch (error) {
                info.usersError = error.message;
            }

            setDebugInfo(info);
        } catch (error) {
            console.error('デバッグ情報の取得に失敗:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (process.env.NODE_ENV === 'development') {
            loadDebugInfo();
        }
    }, [currentUser, accountId]);

    // 本番環境では表示しない
    if (process.env.NODE_ENV !== 'development') {
        return null;
    }

    return (
        <div style={{
            background: '#f8f9fa',
            border: '1px solid #dee2e6',
            borderRadius: '8px',
            padding: '1rem',
            margin: '1rem 0',
            fontFamily: 'monospace',
            fontSize: '0.85rem'
        }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '1rem'
            }}>
                <h4 style={{ margin: 0, color: '#495057' }}>🔍 アカウントデバッグ情報</h4>
                <button
                    onClick={loadDebugInfo}
                    disabled={loading}
                    style={{
                        background: '#6c757d',
                        color: 'white',
                        border: 'none',
                        padding: '0.25rem 0.5rem',
                        borderRadius: '4px',
                        fontSize: '0.75rem'
                    }}
                >
                    {loading ? '読み込み中...' : '更新'}
                </button>
            </div>

            {debugInfo && (
                <pre style={{
                    background: 'white',
                    padding: '1rem',
                    borderRadius: '4px',
                    overflow: 'auto',
                    maxHeight: '300px',
                    margin: 0
                }}>
                    {JSON.stringify(debugInfo, null, 2)}
                </pre>
            )}
        </div>
    );
};

export default AccountDebugger;




